var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import memoize from 'memoize-one';
import { PureComponent } from 'react';
import telephony from './api/telephony';
export const withPhoneSearch = (Component) => {
    class WithPhoneSearch extends PureComponent {
        constructor() {
            super(...arguments);
            this.state = {
                items: {},
                getItemsAsyncStatus: 'succeeded',
            };
            this.memoizedGetInjectedProps = memoize(this.getInjectedProps).bind(this);
        }
        getItems(params, types) {
            this.setState({ getItemsAsyncStatus: 'loading' });
            const { items } = this.state;
            const { country } = params;
            const searchQueries = types.map((type) => telephony.searchNumbers(Object.assign(Object.assign({}, params), { type })));
            return Promise.all(searchQueries)
                .then((resp) => resp.map((response, index) => {
                var _a;
                return (Object.assign(Object.assign({}, response), { 
                    /*
                     * If we're requesting next page or previous page
                     * then we won't be getting `country` from params,
                     * therefor we take it from state if it's not in params.
                     */
                    country: country || ((_a = items[types[index]]) === null || _a === void 0 ? void 0 : _a.country), type: types[index] }));
            }))
                .then(this.handleQueryResolve, this.handleQueryReject);
        }
        handleQueryResolve(response) {
            this.setState(({ items: stateItems }) => {
                const items = response.reduce((list, { data, meta, type, country }) => (Object.assign(Object.assign({}, list), { [type]: {
                        country,
                        groups: data.groups.groups,
                        numbers: data.numbers,
                        nextPagePath: meta.next_page,
                        previousPagePath: meta.prev_page,
                    } })), stateItems);
                return {
                    getItemsAsyncStatus: 'succeeded',
                    items,
                };
            });
            return response;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        handleQueryReject(error) {
            this.setState({ getItemsAsyncStatus: 'failed' });
            return error;
        }
        nextPage(type) {
            var _a;
            const { items } = this.state;
            const nextPagePath = (_a = items[type]) === null || _a === void 0 ? void 0 : _a.nextPagePath;
            if (!nextPagePath) {
                throw new Error('Next page does not exist');
            }
            return this.getItems({ next_page: nextPagePath }, [type]).then(([response]) => response);
        }
        previousPage(type) {
            var _a;
            const { items } = this.state;
            const previousPagePath = (_a = items[type]) === null || _a === void 0 ? void 0 : _a.nextPagePath;
            if (!previousPagePath) {
                throw new Error('Next page does not exist');
            }
            return this.getItems({ prev_page: previousPagePath }, [type]).then(([response]) => response);
        }
        getInjectedProps(items, getItemsAsyncStatus) {
            return {
                items,
                getItemsAsyncStatus,
                getItems: this.getItems,
                nextPage: this.nextPage,
                previousPage: this.previousPage,
            };
        }
        render() {
            const { items, getItemsAsyncStatus } = this.state;
            return (_jsx(Component, Object.assign({}, this.props, { phoneSearch: this.memoizedGetInjectedProps(items, getItemsAsyncStatus) })));
        }
    }
    __decorate([
        boundMethod
    ], WithPhoneSearch.prototype, "getItems", null);
    __decorate([
        boundMethod
    ], WithPhoneSearch.prototype, "handleQueryResolve", null);
    __decorate([
        boundMethod
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ], WithPhoneSearch.prototype, "handleQueryReject", null);
    __decorate([
        boundMethod
    ], WithPhoneSearch.prototype, "nextPage", null);
    __decorate([
        boundMethod
    ], WithPhoneSearch.prototype, "previousPage", null);
    __decorate([
        boundMethod
    ], WithPhoneSearch.prototype, "getInjectedProps", null);
    return WithPhoneSearch;
};
